import { Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { startWithUpperCase } from "../../helpers";
import { IAuthState } from "../../stateManagement/reducers/authReducer";
import {
  addItemToCart,
  ICartState,
} from "../../stateManagement/reducers/cartReducer";
import {
  clearRegRentalItemErrs,
  IRentalItem,
  IRentalItemsState,
  tryFetchRentalItems,
} from "../../stateManagement/reducers/rentalItemsReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import IconText from "../IconText";

interface IAvailableRentalItemsMenuProps {
  setItem: (item: IRentalItem | null) => void;
  reAssigning?: boolean;
  btnText?: string;
}

const AvailableRentalItemsMenu: React.FC<IAvailableRentalItemsMenuProps> = ({
  setItem,
  reAssigning,
  btnText: text = "Add Product",
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch<any>();
  const { authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { fetchingRentalItems, rentalItems, fetchRentalItemsErr } = useSelector<
    IRootReducerT,
    IRentalItemsState
  >((state) => state.rentalItems);
  const { cart } = useSelector<IRootReducerT, ICartState>(
    (state) => state.cart,
  );

  React.useEffect(() => {
    dispatch(
      tryFetchRentalItems({
        authToken: authToken ?? "",
      }),
    );
  }, []);

  const [isInitRender, setIsInitRender] = React.useState(true);

  React.useEffect(() => {
    if (isInitRender) {
      setIsInitRender(false);
      return;
    }

    if (fetchRentalItemsErr) {
      alert(`Error: ${fetchRentalItemsErr}`);
    }
  }, []);

  React.useEffect(() => {
    if (fetchRentalItemsErr) {
      alert(`Error: ${fetchRentalItemsErr}`);

      dispatch(clearRegRentalItemErrs());
    }
  }, [fetchRentalItemsErr]);

  return (
    <div>
      <Button
        id="rentalItems-menu-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        color="primary"
        size="medium"
        onClick={handleClick}
      >
        {text}
      </Button>
      <Menu
        id="rentalItems-positioned-menu"
        aria-labelledby="rentalItems-menu-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ zIndex: 1400000000000000000, position: "absolute" }}
      >
        <Typography p={0.5} variant="body1" color="secondary">
          Select Product
        </Typography>

        {rentalItems.length > 0 &&
          rentalItems.map((item) => {
            return cart.items.find(
              (cartItem) => cartItem.rentalItem._id === item._id,
            ) ? null : (
              <MenuItem
                onClick={(e) => {
                  dispatch(addItemToCart({ rentalItem: item, count: 1 }));
                  handleClose();
                }}
              >
                <IconText
                  iconSrc={item.imgSrc}
                  topText={startWithUpperCase(item.name)}
                  bottomText={""}
                  variant="rounded"
                />
                <Grid
                  container
                  spacing={0.5}
                  direction="column"
                  ml={5}
                  justifyContent="center"
                  alignItems={"flex-end"}
                >
                  <Grid color="secondary" item xs="auto">
                    <Typography variant="body2" color="textSecondary">
                      {`${item.availableCount} available`}
                    </Typography>
                  </Grid>
                </Grid>
              </MenuItem>
            );
          })}
        {rentalItems.length === 0 && fetchingRentalItems && (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="body2"
                color="secondary"
                p={1}
                sx={{ fontWeight: 400, textAlign: "center" }}
              >
                Loading...
              </Typography>
            </Grid>
          </Grid>
        )}
        {rentalItems.length === 0 && !fetchingRentalItems && (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="body2"
                color="secondary"
                p={1}
                sx={{ fontWeight: 400, textAlign: "center" }}
              >
                No Rental Item Yet.
              </Typography>
            </Grid>
          </Grid>
        )}
      </Menu>
    </div>
  );
};

export default AvailableRentalItemsMenu;
